"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = decorateDerive;

var accounts = _interopRequireWildcard(require("./accounts"));

var balances = _interopRequireWildcard(require("./balances"));

var chain = _interopRequireWildcard(require("./chain"));

var democracy = _interopRequireWildcard(require("./democracy"));

var session = _interopRequireWildcard(require("./session"));

var staking = _interopRequireWildcard(require("./staking"));

// Copyright 2017-2019 @polkadot/api-derive authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
// Put all derived functions in an object, for easier Object.keys()-ing.
const functions = {
  accounts,
  balances,
  chain,
  democracy,
  session,
  staking
};
/**
 * T represents the section here (chain, balances...), and P represents
 * the function name (bestNumber, sessionProgress...).
 */

function injectFunctions(api, derive, functions) {
  Object.keys(functions).forEach(sectionName => {
    const section = functions[sectionName];
    const result = derive[sectionName] = derive[sectionName] || {};
    Object.keys(section).forEach(methodName => {
      // @ts-ignore No idea how to make this work...
      result[methodName] = section[methodName](api);
    });
  });
  return derive;
}

function decorateDerive(api) {
  let custom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const derive = {};
  injectFunctions(api, derive, functions);
  injectFunctions(api, derive, custom);
  return derive;
}